import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { always } from 'ramda'
import { env } from '../../utilities/utilities'
import './App.css'

import { Reader } from "../Reader/Reader";

const routerBasename = env({
  dev: always('/'),
  prod: always(process.env.PUBLIC_URL)
})

export const View = () => (
  <div className="App">
    <Router basename={routerBasename}>
      <Route path="**" component={Reader} />
    </Router>
  </div>
)

export const App = View



// WEBPACK FOOTER //
// ./src/components/App/App.js